const CategoryEnum = {
  BLOOD_DISEASES: 'blood_diseases',
  CARDIOVASCULAR: 'cardiovascular',
  CIRCULATORY: 'circulatory',
  DANGER_SIGNS: 'danger_signs',
  DIGESTIVE: 'digestive',
  EAR_AND_MASTOID: 'ear_and_mastoid',
  ENDOCRINE_NUTRITIONAL_METABOLIC: 'endocrine_nutritional_metabolic',
  EYE_ADNEXA: 'eye_adnexa',
  GENITOURINARY: 'genitourinary',
  IMMUNE: 'immune',
  INFECTIOUS_PARASITIC: 'infectious_parasitic',
  INJURY_POISONING_ABUSE: 'injury_poisoning_abuse',
  MENTAL_BEHAVIOURAL: 'mental_behavioural',
  MUSCULOSKELETAL: 'musculoskeletal',
  NERVOUS_SYSTEM: 'nervous_system',
  OTHER_ILLNESS: 'other_illness',
  PREGNANCY_CHILDBIRTH_PERINATAL_PUERPERIUM: 'pregnancy_childbirth_perinatal_puerperium',
  RESPIRATORY: 'respiratory',
  SKIN_SUBCUTANEOUS: 'skin_subcutaneous',
};

module.exports = CategoryEnum;
